import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card p-6 sm:p-8 mb-4"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "สรุปการสั่งซื้อ", -1)
const _hoisted_5 = { class: "flex flex-col space-y-2 px-2 py-4" }
const _hoisted_6 = { class: "flex flex-row text-base" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "ราคา", -1)
const _hoisted_8 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row text-base"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "ค่าขนส่ง", -1)
const _hoisted_11 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-row text-base"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "ยอดรวมก่อนภาษี", -1)
const _hoisted_14 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_15 = {
  key: 2,
  class: "flex flex-row text-base"
}
const _hoisted_16 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_17 = {
  key: 3,
  class: "flex flex-row text-base"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "ยอดรวมทั้งสิ้น", -1)
const _hoisted_19 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_20 = { class: "flex flex-col space-y-2 px-2 py-4" }
const _hoisted_21 = { class: "flex flex-row items-center mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "ราคารวม:", -1)
const _hoisted_23 = {
  class: "flex text-xl flex-auto justify-end",
  style: {"color":"#31bfc7"}
}
const _hoisted_24 = { class: "fixed bottom-0 left-0 w-full p-3 bg-white z-20 xl:relative flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "bullet_main",
            src: require('@/assets/icon_bullet/summarize.svg'),
            alt: ""
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.currency(_ctx.data.accountingData.grandTotalAmount)) + " บาท ", 1)
          ]),
          (!_ctx.data.hasNoShipment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.data.accountingData.shippingCost == null
              ? "รอเลือกการขนส่ง"
              : _ctx.data.accountingData.shippingCost == 0
              ? "ฟรีค่าจัดส่ง"
              : _ctx.currency(_ctx.data.accountingData.shippingCost)) + " " + _toDisplayString(_ctx.data.accountingData.shippingCost == null
              ? ""
              : _ctx.data.accountingData.shippingCost == 0
              ? ""
              : "บาท"), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.currency((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost) - _ctx.data.accountingData.vat)) + " บาท ", 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("p", null, "ภาษีมูลค่าเพิ่ม (" + _toDisplayString(_ctx.data.accountingData.vatPercentage) + "%)", 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.currency(((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost) * _ctx.data.accountingData.vatPercentage) / 100)) + " บาท ", 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.currency((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost) + ((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost) * _ctx.data.accountingData.vatPercentage) / 100)) + " บาท ", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("p", _hoisted_23, _toDisplayString(!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0 ? _ctx.currency((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost) + ((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost) * _ctx.data.accountingData.vatPercentage) / 100) : _ctx.currency((_ctx.data.accountingData.grandTotalAmount + _ctx.data.accountingData.shippingCost))) + " บาท ", 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-send'))),
              class: "group relative w-full flex justify-center py-4 px-4 border border-transparent text-lg font-medium rounded-md text-white bg-green-island-500 hover:bg-green-island-600 focus:outline-none focus:ring-transparent"
            }, _toDisplayString(_ctx.data.hasNoShipment ? "ยืนยันการสั่งซื้อ" : "ยืนยันข้อมูลการจัดส่ง"), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}